import React, { useState } from 'react';
import {
    Box,
    Button,
    Center,
    Flex,
    FormControl,
    FormErrorMessage,
    Image,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    useToast
} from "@chakra-ui/react";
import LoginGraphics from "../../images/login_graphics.png";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { onHandelLogin, onForgotPassword, onVerifyOtp, onResetPassword } from '../../http/login';
import { Credencials } from "../../interfaes/user";
import Joi from 'joi';
import { errorFormat, FormattedError, getErrorMessage, hasErrorMessage } from '../../utils/formUtils';
import Footer from '../../components/Footer';

export default function LoginPage() {
    const toast = useToast()
    const schema = Joi.object({
        username: Joi.string()
            .min(3)
            .max(50)
            .required(),

        password: Joi.string().required()
    });

    const [loading, setLoading] = useState<boolean>(false);


    const navigate = useNavigate();
    const { t } = useTranslation('login');
    const [show, setShow] = React.useState(false)
    const [loginObj, setLoginObj] = useState<Credencials>({
        username: "",
        password: ""
    });
    const [formErrors, setFormErrors] = useState<FormattedError[]>([]);
    const handleClick = () => setShow(!show)

    // Forgot Password States
    const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
    const [step, setStep] = useState(1); // 1: Mobile, 2: OTP, 3: Reset
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [timer, setTimer] = useState(0);

    const validateObj = () => {
        const { error } = schema.validate(loginObj);

        if (error) {
            setFormErrors(errorFormat(error.details));
            return false;
        }

        setFormErrors([]);
        return true;
    }

    const onLogin = async () => {
        if (validateObj()) {
            try {
                setLoading(true);


                const response = await onHandelLogin(loginObj);
                localStorage.setItem('user', JSON.stringify(response.data));
                setLoading(false);
                toast({
                    title: 'Welcome!!!',
                    description: "Welcome to IEP!!",
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                })
                navigate('/');
            } catch (e) {
                console.log(e)
                setLoading(false);
                toast({
                    title: 'Someting Went Wrong',
                    description: "We could not login at the moment. Please contact authorities for support.",
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                })
            }
        }

    }

    // Forgot Password Handlers
    const handleSendOtp = async () => {
        if (!mobile || mobile.length !== 10) {
            toast({ title: "Error", description: "Please enter just 10 letters mobile number", status: "error", duration: 3000 });
            return;
        }
        setLoading(true);
        console.log("Attempting to send OTP to:", mobile);
        try {
            console.log("onForgotPassword import check:", typeof onForgotPassword);
            await onForgotPassword(mobile);
            setStep(2);
            setTimer(60);
            const interval = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) clearInterval(interval);
                    return prev - 1;
                });
            }, 1000);
            toast({ title: "Success", description: "OTP sent successfully", status: "success", duration: 3000 });
        } catch (e: any) {
            console.error("handleSendOtp failed:", e);
            const errorMsg = e.response?.data?.message || (typeof e.response?.data === 'string' ? e.response.data : "Failed to send OTP");
            toast({ title: "Error", description: errorMsg, status: "error", duration: 5000 });
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async () => {
        setLoading(true);
        try {
            await onVerifyOtp(mobile, otp);
            setStep(3);
            toast({ title: "Success", description: "OTP Verified", status: "success", duration: 3000 });
        } catch (e: any) {
            const errorMsg = e.response?.data?.message || (typeof e.response?.data === 'string' ? e.response.data : "Invalid OTP");
            toast({ title: "Error", description: errorMsg, status: "error", duration: 5000 });
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async () => {
        if (newPassword !== confirmPassword) {
            toast({ title: "Error", description: "Passwords do not match", status: "error", duration: 3000 });
            return;
        }
        setLoading(true);
        try {
            await onResetPassword({ mobile, otp, newPassword, confirmPassword });
            toast({ title: "Success", description: "Password Changed. Please Login.", status: "success", duration: 3000 });
            setForgotPasswordMode(false);
            setStep(1);
            setMobile(""); setOtp(""); setNewPassword(""); setConfirmPassword("");
        } catch (e: any) {
            const errorMsg = e.response?.data?.message || (typeof e.response?.data === 'string' ? e.response.data : "Failed to reset password");
            toast({ title: "Error", description: errorMsg, status: "error", duration: 5000 });
        } finally {
            setLoading(false);
        }
    };

    return (<Flex height={"100vh"} direction={{ base: "column", md: "row" }}>
        <Box w={{ base: "100%", md: "50%" }} display={{ base: "none", md: "flex" }} background={"#f9fbfc"}>
            <Box m="auto" px={{ base: 4, md: 8 }}>
                <Box>
                    <Text fontSize={{ base: "24px", md: "30px" }} fontWeight={900} textAlign={"center"}>
                        {t('login:appName')}
                    </Text>
                </Box>
                <Center>
                    <Box boxSize={{ base: 'xs', md: 'sm' }}>
                        <Image src={LoginGraphics} />
                    </Box>
                </Center>
                <Box mt={8} display={{ base: "none", lg: "block" }}>
                    <Footer />
                </Box>
            </Box>
        </Box>
        <Box w={{ base: "100%", md: "50%" }} background={"#1b73e8"} display={"flex"} minH={{ base: "100vh", md: "auto" }}>
            <Box px={{ base: 6, md: 12 }} py={{ base: 8, md: 0 }} mt={{ base: "auto", md: "auto" }} mb={{ base: "auto", md: "auto" }} w={"100%"} maxW={{ base: "100%", md: "500px" }} mx="auto">
                <Box display={{ base: "block", md: "none" }} mb={{ base: 8, md: 4 }}>
                    <Text fontSize={{ base: "24px", md: "30px" }} fontWeight={900} textAlign={"center"} color={"#ffffff"}>
                        {t('login:appName')}
                    </Text>
                </Box>

                {!forgotPasswordMode ? (
                    <>
                        <Text fontSize={{ base: "24px", md: "30px" }} fontWeight={900} textAlign={"center"} color={"#ffffff"} mb={{ base: 6, md: 8 }}>
                            {t('login:loginText')}
                        </Text>
                        <Box mb={{ base: 4, md: 6 }}>
                            <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                {t('login:userName')}
                            </Text>
                            <FormControl isInvalid={hasErrorMessage(formErrors, 'username')} isRequired>
                                <Input
                                    background={"#ffffff"}
                                    size={{ base: "md", md: "lg" }}
                                    fontSize={{ base: "14px", md: "16px" }}
                                    _focus={{
                                        bg: '#ffffff',
                                    }}
                                    pr='4.5rem'
                                    type={'text'}
                                    value={loginObj.username}
                                    variant='filled'
                                    onChange={(e) => setLoginObj({ ...loginObj, username: e.target.value || '' })}
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'username')}</FormErrorMessage>
                            </FormControl>

                        </Box>
                        <Box mt={{ base: 4, md: 6 }}>
                            <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                {t('login:password')}
                            </Text>
                            <FormControl isInvalid={hasErrorMessage(formErrors, 'password')} isRequired>
                                <InputGroup size={{ base: "md", md: "lg" }}>

                                    <Input
                                        background={"#ffffff"}
                                        fontSize={{ base: "14px", md: "16px" }}
                                        _focus={{
                                            bg: '#ffffff',
                                        }}
                                        pr='4.5rem'
                                        type={show ? 'text' : 'password'}
                                        variant='filled'
                                        value={loginObj.password}
                                        onChange={(e) => setLoginObj({ ...loginObj, password: e.target.value || '' })}

                                    />
                                    <InputRightElement width='4.5rem'>
                                        <Button h='1.75rem' size='sm' onClick={handleClick}>
                                            {show ? t('login:hide') : t('login:show')}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'password')}</FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Text
                            color={"#ffffff"}
                            mt={2}
                            fontSize="sm"
                            cursor="pointer"
                            textAlign="right"
                            _hover={{ textDecoration: 'underline' }}
                            onClick={() => setForgotPasswordMode(true)}
                        >
                            Forgot Password?
                        </Text>
                        <Button
                            w="100%"
                            background={"#004aad"}
                            color={"#ffffff"}
                            border={"1px solid #ffffff"}
                            mt={{ base: 6, md: 8 }}
                            size={{ base: "md", md: "lg" }}
                            fontSize={{ base: "16px", md: "18px" }}
                            fontWeight={700}
                            _hover={{
                                background: '#ffffff', color: '#004aad', border: '1px solid #004aad'
                            }}
                            onClick={onLogin}
                            isLoading={loading} isDisabled={loading}
                        >
                            {t('login:loginBtn')}
                        </Button>
                    </>
                ) : (
                    <Box>
                        <Text fontSize={{ base: "24px", md: "30px" }} fontWeight={900} textAlign={"center"} color={"#ffffff"} mb={{ base: 6, md: 8 }}>
                            Forgot Password
                        </Text>

                        {step === 1 && (
                            <Box>
                                <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                    Mobile Number
                                </Text>
                                <Input
                                    background={"#ffffff"}
                                    size="lg"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                                <Button
                                    w="100%"
                                    mt={4}
                                    colorScheme="blue"
                                    onClick={handleSendOtp}
                                    isLoading={loading}
                                >
                                    Send OTP
                                </Button>
                            </Box>
                        )}

                        {step === 2 && (
                            <Box>
                                <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                    Enter OTP
                                </Text>
                                <Input
                                    background={"#ffffff"}
                                    size="lg"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                />
                                <Button
                                    w="100%"
                                    mt={4}
                                    colorScheme="blue"
                                    onClick={handleVerifyOtp}
                                    isLoading={loading}
                                >
                                    Verify OTP
                                </Button>
                                {timer > 0 ? (
                                    <Text color="white" mt={2} textAlign="center">Resend OTP in {timer}s</Text>
                                ) : (
                                    <Button variant="link" color="white" mt={2} w="100%" onClick={handleSendOtp}>Resend OTP</Button>
                                )}
                            </Box>
                        )}

                        {step === 3 && (
                            <Box>
                                <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                    New Password
                                </Text>
                                <Input
                                    background={"#ffffff"}
                                    size="lg"
                                    type="password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    mb={4}
                                />
                                <Text color={"#ffffff"} mb={"8px"} fontSize={{ base: "14px", md: "16px" }} fontWeight={600}>
                                    Confirm Password
                                </Text>
                                <Input
                                    background={"#ffffff"}
                                    size="lg"
                                    type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <Button
                                    w="100%"
                                    mt={4}
                                    colorScheme="blue"
                                    onClick={handleResetPassword}
                                    isLoading={loading}
                                >
                                    Change Password
                                </Button>
                            </Box>
                        )}

                        <Button
                            variant="link"
                            color="white"
                            mt={4}
                            w="100%"
                            onClick={() => { setForgotPasswordMode(false); setStep(1); }}
                        >
                            Back to Login
                        </Button>
                    </Box>
                )}
                <Box mt={8} display={{ base: "block", lg: "none" }}>
                    <Footer color="white" linkColor="#ffff00" />
                </Box>
            </Box>
        </Box>
    </Flex>)
}
